import { render, staticRenderFns } from "./businessForm.vue?vue&type=template&id=40c04e50&scoped=true&"
import script from "./businessForm.vue?vue&type=script&lang=js&"
export * from "./businessForm.vue?vue&type=script&lang=js&"
import style0 from "./businessForm.vue?vue&type=style&index=0&id=40c04e50&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c04e50",
  null
  
)

export default component.exports